$(() => {
  const fotoramaContainer = $('.fotorama');
  let fotorama;
  let showArrows;

  function showFullScreenOnClick() {
    $(document).on('click', '.fotorama', (e) => {
      // check that we clicked on an image rather
      // than a navigation arrow
      const clickedElement = $(e.target);

      // Get parent fotorama gallery data
      const parentFotoramaContainer = clickedElement.parents('.fotorama');
      fotorama = parentFotoramaContainer.data('fotorama');

      // Make sure we're not clicking a thumbnail
      const clickedFullImage = clickedElement.parent('.fotorama__stage__frame').length > 0;


      if (clickedElement.is('img') && clickedFullImage) {
        fotorama.requestFullScreen();
      }
    });
  }

  function cancelFullScreenOnClickOutsideImage() {
    $(document).on('click', '.fotorama__stage__frame.fotorama__loaded--full.fotorama__active', (e) => {
      const clickedElement = $(e.target);
      if (!clickedElement.is('img')) {
        try {
          fotorama.cancelFullScreen();
        } catch (e) {
          // Likely related to poor browser detection in this older library
          // There is some similar conversation about fancybox that may be the source
          // of this error.
          //
          // Started in 5.312.2
          // https://sentry.io/organizations/reverb-llc/releases/5.312.2/
          // https://github.com/fancyapps/fancybox/issues/2284
          // https://sentry.io/organizations/reverb-llc/issues/1404685687/?project=1270493&query=is%3Aunresolved
          console.log(e);
        }
      }
    });
  }

  if (!Reverb.MobileDetection.isMobileBrowser()) {
    showFullScreenOnClick();
    cancelFullScreenOnClickOutsideImage();
    showArrows = 'true';
  } else {
    showArrows = 'always';
  }

  // Disable swipe on desktop devices, mobile only
  fotoramaContainer.fotorama({
    swipe: Reverb.MobileDetection.isMobileBrowser(),
    arrows: showArrows,
    loop: true,
  });
});
